import { IUser } from '~/types/user-info-types'
import { RegisterFields } from '~/types/sign-up'
import { UserField } from '~/types/user'

const detailsStepRequiredFields = [UserField.NICKNAME, UserField.BIRTH_YEAR, UserField.COUNTRY, UserField.SKILL]

export function isDetailsStepComplete(user: Partial<RegisterFields>): boolean {
  return detailsStepRequiredFields.every((field) => {
    const value = user[field]
    const isEmptyString = typeof value === 'string' && value.trim() === ''

    return value != null && !isEmptyString
  })
}

export function isAccountTypeStepComplete(user: IUser): boolean {
  return user.userType != null
}

export function isUserDetailsComplete(user: IUser): boolean {
  const userEmail = user?.facebookEmail || user?.email || user?.authEmail
  const parsedBirthYear = Number.parseInt(user?.birthYear || '')
  return !!userEmail && !!user?.nickname && !!parsedBirthYear && !!user?.country && (!!user?.skill || user?.skill === 0)
}

export function isMappingQuizStepComplete(quizStatus: { hasQuiz: boolean; hasPendingQuiz: boolean }): boolean {
  return !quizStatus.hasQuiz && !quizStatus.hasPendingQuiz
}

export function isAvatarStepComplete(user: IUser): boolean {
  return Boolean(user.avatarPngUrl)
}
